import { Record } from 'immutable';
import Article from '../ArticleRecord';
const ArticleDetailsRecord = Record({
  article: new Article(),
  error: undefined,
  isRequesting: false,
  lastLoaded: null
});
export default ArticleDetailsRecord;